import styled from 'styled-components';
import { FlexLayout } from '@gv/triage-components';

export const Container = styled(FlexLayout)`
  gap: 24px;
  padding: 16px;
  flex-direction: column;
  border-top: 1px solid ${({ theme }) => theme.config.border};
`;
